import React from 'react';
import ScanPrintContent from '../shared/ScanPrintContent';

const AdminScanPrint = () => {
  return <ScanPrintContent />;
};

export default AdminScanPrint;
